import React from 'react';

import Sidebar from '../../components/Sidebar';

/**
 * HomePage — shown when all feature flags (AI Chat, Communication, Workflows)
 * are disabled. Keeps the sidebar accessible so users can still navigate
 * settings, integrations, and other left-side features.
 */
const HomePage = () => {
  return (
    <div className="bg-3 text-p-text relative flex h-screen max-h-[100svh] w-screen flex-col gap-2 overflow-hidden p-2 md:flex-row md:gap-2 md:p-2">
      {/* Desktop sidebar */}
      <div className="relative hidden h-full w-56 flex-shrink-0 overflow-hidden rounded-2xl border border-zinc-700 md:block">
        <Sidebar toggleSidebar={false} isOpen={false} onToggle={() => {}} />
      </div>

      {/* Main content area */}
      <div className="bg-1 flex min-h-0 flex-1 flex-col items-center justify-center gap-4 overflow-hidden rounded-2xl border border-zinc-700">
        <div className="flex flex-col items-center gap-3 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-zinc-700 bg-zinc-800">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-7 w-7 text-zinc-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
          </div>
          <p className="text-sm font-medium text-zinc-400">
            No features enabled
          </p>
          <p className="max-w-xs text-xs text-zinc-600">
            Enable{' '}
            <code className="rounded bg-zinc-800 px-1 py-0.5 text-zinc-400">
              ENABLE_AI_CHAT
            </code>
            ,{' '}
            <code className="rounded bg-zinc-800 px-1 py-0.5 text-zinc-400">
              ENABLE_COMMUNICATION
            </code>
            , or{' '}
            <code className="rounded bg-zinc-800 px-1 py-0.5 text-zinc-400">
              ENABLE_WORKFLOWS
            </code>{' '}
            in{' '}
            <code className="rounded bg-zinc-800 px-1 py-0.5 text-zinc-400">
              src/config/features.js
            </code>{' '}
            to get started.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
